module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cz-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("充值")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "alipayform",
    attrs: {
      "action": "api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253",
      "name": "transferForm",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("充值金额:")]), _vm._v(" "), _c('div', {
    staticClass: "einput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payModel),
      expression: "payModel"
    }],
    attrs: {
      "type": "text",
      "id": "WIDtotal_fee",
      "name": "WIDtotal_fee",
      "value": "10"
    },
    domProps: {
      "value": (_vm.payModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payModel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "mark"
  }, [_vm._v("注意：付款金额，必填(格式如：1,1元的整数倍)")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('input', {
    staticClass: "alisubmit",
    attrs: {
      "type": "button",
      "value": "使用支付宝充值"
    },
    on: {
      "click": _vm.aliPay
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "forms"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/account_logo.png"),
      "width": "200"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element",
    staticStyle: {
      "display": "none"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "tokenId",
      "name": "tokenId",
      "value": "798cc3d3-56b0-44b2-848a-a3d6d306f253"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f0fb77c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account-center/showAlipay.vue
// module id = 1526
// module chunks = 1